const Upload = ({ progress }) => {
  const numb = document.querySelector('.number');
  // let counter = 0;
  // setInterval(() => {
  //   if (counter === 100) {
  //     clearInterval();
  //   } else {
  //     counter += 1;
  //     numb.textContent = counter + "%";
  //   }
  // }, 80);

  return (
    <div>
      <div className='circular'>
        <div className='inner'></div>
        <div className='number'>{progress}%</div>
        <div className='circle'>
          <div className='bar left'>
            <div className='progress'></div>
          </div>
          <div className='bar right'>
            <div className='progress'></div>
          </div>
        </div>
      </div>
      <p>Uploading file...</p>
    </div>
  );
};

export default Upload;
